import { render, staticRenderFns } from "./HandleConvocationLogin.vue?vue&type=template&id=a79ca720"
import script from "./HandleConvocationLogin.vue?vue&type=script&lang=js"
export * from "./HandleConvocationLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports